import { createContext, useState } from "react";

export const OnboardingContext = createContext();

export function OnboardingProvider({ children }) {
  const [sessionId, setSessionId] = useState(null);
  const [orgName, setOrgName] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [currentStep, setCurrentStep] = useState("start");
  const [inviteToken, setInviteToken] = useState("");

  return (
    <OnboardingContext.Provider
      value={{
        sessionId, setSessionId,
        orgName, setOrgName,
        adminEmail, setAdminEmail,
        inviteToken, setInviteToken,
        currentStep, setCurrentStep
      }}

    >
      {children}
    </OnboardingContext.Provider>
  );
}